module.exports = __webpack_public_path__ + "img/technical.1267bb6a.png";